export default __webpack_public_path__ + "static/media/invite-icon-active.c58c59fc.svg";